import { css } from '@emotion/react';
import {
  type FC, type ReactNode,
} from 'react';
import { Inline } from '~/_shared/baseComponents/layout/inline.component';
import { FloatingBoxComponent } from '~/_shared/components/floatingBox/floatingBox.component';
import { useTranslation } from '~/_shared/utils/hooks';

const stepRowStyle = css({
  alignItems: 'baseline',
  display: 'flex',
  width: '100%',
});

const stepLabelStyle = css({
  flexShrink: 0,
  fontWeight: 700,
  whiteSpace: 'nowrap',
});

type ToolInstructionsBoxProps = Readonly<{
  className?: string;
  heading?: string;
  steps: ReadonlyArray<ReactNode>;

  onClose?: () => void;
}>;

export const ToolInstructionsBoxComponent: FC<ToolInstructionsBoxProps> = ({
  className,
  heading,
  onClose,
  steps,
}) => {
  const [t] = useTranslation();

  return (
    <FloatingBoxComponent
      css={className}
      gap={12}
      heading={heading}
      isOpen
      onClose={onClose}
    >
      {steps.map((step, index) => (
        <Inline
          css={stepRowStyle}
          gap={8}
          key={index}
          wrap="nowrap"
        >
          <span css={stepLabelStyle}>
            {t('Step {{step}}', { step: index + 1 })}:
          </span>
          <span>{step}</span>
        </Inline>
      ))}
    </FloatingBoxComponent>
  );
};
